import  {__extends} from './eXcell';
import eXcell_ed from './eXcell_ed';

var eXcell_edn = (function (_super) {
    __extends(eXcell_edn, _super);
    function eXcell_edn(a) {
        _super.call(this, a);
        if (a) {
            this.cell = a;
            this.grid = this.cell.parentNode.grid;
        }
    }
    eXcell_edn.prototype.getValue = function () {
        if (this.cell.firstChild && this.cell.firstChild.tagName == "TEXTAREA") {
            return this.cell.firstChild.value;
        }
        if (this.cell._clearCell) {
            return "";
        }
        return (this.cell._orig_value ||
            this.grid._aplNFb(this.cell.innerHTML.toString()._dhx_trim(), this.cell._cellIndex));
    };
    eXcell_edn.prototype.detach = function () {
        var c = this.obj.value;
        this.setValue(c);
        return this.val != this.getValue();
    };
    return eXcell_edn;
})(eXcell_ed);
eXcell_edn.prototype.setValue = function (a) {
    if (!a || a.toString()._dhx_trim() == "") {
        this.cell._clearCell = true;
        return this.setCValue("&nbsp;", 0);
    }
    else {
        this.cell._clearCell = false;
        this.cell._orig_value = a;
    }
    this.setCValue(this.grid._aplNF(a, this.cell._cellIndex), a);
};
window.eXcell_edn = eXcell_edn;

export default eXcell_edn;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_edn.js